import type { VirtualChatRow } from '../../../../types';
import { ChatDayDivider } from '../../../chat-day-divider';
import { ChatMessageRow } from '../../../chat-message-row';

type P = {
  row: VirtualChatRow;
};

const VirtualChatRowContent = ({ row }: P) => {
  switch (row.kind) {
    case 'day-divider':
      return <ChatDayDivider date={row.date} />;
    case 'message':
      return <ChatMessageRow row={row} />;
  }
};

export default VirtualChatRowContent;
